import Names from 'color-name';

interface ColorNames {
  [index: string]: [number, number, number];
}

export default Names as ColorNames;
